import React from "react";
import styled from "styled-components";

import {Box, Button} from "@unibuddy/patron";
import {IconXMark} from "@unibuddy/icons";
import {sharedEvents} from "shared/AnalyticsNew/constants/productSpecification";
import useAnalytics from "shared/AnalyticsNew/hooks/useAnalytics";

import {DescriptionSection} from "./DescriptionSection";
import {ChatSection} from "./ChatSection";
import {useIsScreenSizeLargerThan} from "../../../../../../hooks/useIsScreenSizeLargerThan";
import {useUniversity} from "../../../../UniversityProvider/UniversityProvider";

const StyledButton = styled(Button)`
    margin: 0;
`;

type WidgetValuePropositionProps = {
    onViewStudents: () => void;
};
export function WidgetValueProposition({onViewStudents}: WidgetValuePropositionProps) {
    const [isWidgetValuePropositionOpen, setIsWidgetValuePropositionOpen] = React.useState(true);
    const university = useUniversity();
    const {trackEvent} = useAnalytics();
    const onValuePropClose = () => {
        setIsWidgetValuePropositionOpen(false);
        trackEvent(sharedEvents.widgetValuePropositionImageDismissed.name, {
            universitySlug: university?.slug,
            cta: "View Students",
            where: "Value Prop Section",
        });
    };

    const onChatStudentsClicked = () => {
        onViewStudents();
        trackEvent(sharedEvents.viewStudentButtonClicked.name, {
            universitySlug: university?.slug,
            cta: "Dismiss",
            where: "Value Prop Section",
        });
    };

    const isRow = useIsScreenSizeLargerThan(632);

    return (
        isWidgetValuePropositionOpen && (
            <Box marginBottom="medium">
                <Box display="flex" flexDirection="row" justifyContent="flex-end" width="100%">
                    <StyledButton
                        onClick={onValuePropClose}
                        iconOnly
                        clear
                        round
                        aria-label="Close value proposition popup"
                    >
                        <IconXMark />
                    </StyledButton>
                </Box>

                <Box
                    display="flex"
                    flexDirection={isRow ? "row" : "column"}
                    alignItems={isRow ? "center" : "flex-start"}
                    justifyContent="space-between"
                    paddingBottom="medium-large"
                >
                    <Box marginBottom={isRow ? "none" : "medium-large"}>
                        <DescriptionSection onViewStudentsClicked={onChatStudentsClicked} />
                    </Box>
                    <ChatSection />
                </Box>
            </Box>
        )
    );
}
